import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const ConfirmDeleteDialog = ({ open, onOpenChange, title, description, onConfirm, testId = "confirm-delete" }) => {
  const [busy, setBusy] = useState(false);
  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onConfirm(); onOpenChange(false); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={`${testId}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`} disabled={busy}>Annulla</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testId}-confirm`} onClick={confirm} disabled={busy} className="bg-red-600 hover:bg-red-700 text-white">
            {busy ? "Eliminazione…" : "Conferma eliminazione"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
